<template>
 
        <div :class="v_css=='true'?'main_back':'main_back2'" v-wechat-title="$route.meta.title">           
            <div style="background: #5cadff;width:100%; ">
                <div style="height:50px;margin-top:3px;display :flex">
                    <el-link :underline="false" @click="mainPage">
                        <img style="height:50px;margin-right:10px;color:#5cadff; " src="@/assets/title.png"/>
                    </el-link>
                    <div style="border-left:3px solid white;margin-left:15px;margin-right:15px; height:30px;margin-top:13px;"> </div>
                    <i class="web-font" style="color:#2d8cf0;font-weight: 700;font-size: 18px;line-height:50px;color:white;margin-top:1px; ">供应商注册</i>
                </div>
            </div>
            <div style="background:#Fff;line-height:40px; margin-top:5px ;text-align:left;font-size:14px;font-weight:600;color:#389">
                温馨提示：注册成功后,待系统管理员审核并分配权限后可登录使用，登录账号为绑定手机号码，初始密码为 2022。
            </div>
            <div :style="{'overflow-y':'auto',height:tabHeight }" > 
            <div v-for="(gpitem,gpind) in formArr" :key="gpind" >
                <div v-if="gpitem.gpno!=='304'&&gpitem.gpno!=='400070'&&gpitem.gpno!=='400071'" style="color:#fff;border-left:4px solid #5cadee; line-height:35px;background:#808695; padding-left:8px;margin-bottom:10px;text-align:left ">
                    
                    <span style="font-weight:600;font-size:14px;color:#fff;">{{gpitem.gpnm}} </span> 
                    <el-link v-if="gpitem.gpno==='20284'" :underline="false" @click="perAdd">【新增记录】</el-link>        
                </div>
                <Form :model="perRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in gpitem.gplist" :key="index" >
                        
                        <FormItem  :label="item.FLDNM"  :class="item.FLDNO=='BANKADDR'?'item-width2':'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'&&item.FLDNO!=='ISREG'&& item.FLDNO!=='ADDUSER'&&item.FLDNO!=='ADDDTTM'&&item.FLDNO!=='PAYMTH'">                  
                            <el-date-picker   type="date"  v-if="item.EDCSS==='date'" v-model="perRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number  v-else-if="item.EDCSS==='number'" v-model="perRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                            <el-checkbox :disabled="item.DISABLED=='Y'" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="perRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                            <el-select  v-else-if="item.EDCSS==='select'" v-model="perRow[item.FLDNO]" :disabled="item.FLDNO=='SUPTY' "  style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select> 
                            <el-cascader v-else-if=" item.FLDNO==='AREA'"  style="width:100%; " placeholder="可输入关键字查找"
                                v-model="perRow[item.FLDNO]"  
                                clearable
                                filterable
                                :options="areaArr">
                            </el-cascader>
                            <el-input  type="text" v-else :disabled="item.DISABLED==='Y'?true:false"  v-model="perRow[item.FLDNO]"></el-input>
                        </FormItem>
                       
                    </span>
                     
                </Form>
            </div>
            <div  style="color:#fff;border-left:4px solid #5cadee; line-height:35px;background:#808695; padding-left:8px;text-align :left ">
        
                <span style="font-weight:600;font-size:14px;color:#fff">联系人资料 </span> 
                <el-link  :underline="false" @click="perAdd" >
                    【<i class="iconfont icon-xinzeng" style="color:#fFF;font-size:12px;margin-right:2px;margin-left:2px;">新增联系人</i>】
                </el-link>        
            </div>
            <el-table  :data="perData" 
                border                            
                size="small"
                ref="pertab"
                :height="200" 
                highlight-current-row > 
                <span v-for="(item ) in perCol" :key="item.key" >
                    <el-table-column  v-if="item.thide==='N'&&item.key!=='STFG'"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"  
                        :fixed="item.key==='EMPNM'"                                
                        sortable
                        :min-width="item.width">
                    </el-table-column> 
                    <el-table-column  v-if="item.key==='STFG'"
                        :prop="item.key"
                        :label="item.title"
                        align="center"                                  
                        width="70">
                        <template slot-scope="scope" >
                            <el-checkbox disabled false-label="N" true-label="Y" v-model="scope.row.STFG" >&nbsp;</el-checkbox>
                        </template>
                    </el-table-column> 
                </span> 
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="150">
                    <template slot-scope="scope">
                        <el-button size="small"   type="text" icon="el-icon-edit" @click="perEdit(scope.row,scope.$index)">编辑</el-button>
                        <el-button size="small"  type="text" icon="el-icon-close" @click="perDel(scope.row,scope.$index)">删除</el-button>   
                    </template>
                </el-table-column>                        
            </el-table>
            <div  style="color:#fff; border-left:4px solid #5cadee;line-height:35px;background:#808695; padding-left:8px;text-align :left ">
          
                <span style="font-weight:600;font-size:14px;color:#fff">上传营业执照附件 * （最多3个文档，可以是PDF或图片格式）</span>         
            </div>
            <div style="display:flex;margin-top:5px;" >
                <Upload
                    name="upfile"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="beforeImgFile"
                    :on-success="successImgFile"
                    :on-progress="handleProgress"
                    :with-credentials="true"                            
                    :format="['jpg','jpeg','png','gif','tiff' ,'pdf']"
                    :max-size="10240"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    type="drag"       
                    :action="uploadUrl"
                    style="display: inline-block;width:200px; ">                           
                    <div style="padding: 1px 0;width:200px;height:183px;">
                        <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                        <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                    </div>                                                       
                </Upload> 
                <div style="display:flex;margin-left:30px;height:193px;flex-wrap:wrap"  >
                    <div v-if="MERPATH" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="MERPATH &&MERPATH.indexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="MERPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else fit="fill"  style="width:200px;height:150px;" :src="MERPATH">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片或PDF文档未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link  :underline="false" @click="imgDel('MER',0)"><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( MERPATH)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="MERPATH2" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="MERPATH2 &&MERPATH2.indexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="MERPATH2" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else fit="fill"  style="width:200px;height:150px;" :src="MERPATH2">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片或PDF文档未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link  :underline="false" @click="imgDel('MER',1)"><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( MERPATH2)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="MERPATH3" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="MERPATH3 &&MERPATH3.indexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="MERPATH3" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else fit="fill"  style="width:200px;height:150px;" :src="MERPATH3">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片或PDF文档未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link   :underline="false" @click="imgDel('MER',2)"><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( MERPATH3)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                </div>
            </div>
            <div  style="color:#fff;border-left:4px solid #5cadee; line-height:35px;background:#808695; padding-left:8px;text-align :left ">
              
                <span style="font-weight:600;font-size:14px;color:#fff">上传资格证书附件 （最多3个文档，可以是PDF或图片格式）</span>         
            </div>
            <div style="display:flex;margin-top:5px" >
                <Upload
                    name="upfile"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="beforeImgFile"
                    :on-success="successCrtFile"
                    :on-progress="handleProgress"
                    :with-credentials="true"                            
                    :format="['jpg','jpeg','png','gif','tiff','pdf' ]"
                    :max-size="10240"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    type="drag"       
                    :action="uploadUrl"
                    style="display: inline-block;width:200px; ">                           
                    <div style="padding: 1px 0;width:200px;height:180px;">
                        <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                        <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                    </div>                                                       
                </Upload> 
                <div  style="display:flex;margin-left:30px;height:193px;flex-wrap:wrap"  >
                    <div v-if="CRTPATH" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="CRTPATH &&CRTPATH.indexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="CRTPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else fit="fill"  style="width:200px;height:150px;" :src="CRTPATH">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片或PDF文档未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link   :underline="false" @click="imgDel('CRT',0)"><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( CRTPATH)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="CRTPATH2" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="CRTPATH2 &&CRTPATH2.indexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="CRTPATH2" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else fit="fill"  style="width:200px;height:150px;" :src="CRTPATH2">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片或PDF文档未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link   :underline="false" @click="imgDel('CRT',1)"><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview(CRTPATH2)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="CRTPATH3" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="CRTPATH3 &&CRTPATH3.indexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="CRTPATH3" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else fit="fill"  style="width:200px;height:150px;" :src="CRTPATH3">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片或PDF文档未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link  :underline="false" @click="imgDel('CRT',2)"><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview(CRTPATH3)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                </div>    
            </div>
            </div>
            <div class="bottomdiv">
                <div style="width:116px;font-size:18px;float:right  ">
                    <el-button   class="paybtn" @click="saveRec"  ><i class="iconfont icon-tijiao" style="margin-right:5px;"></i>提交注册</el-button>
                </div>
            </div>
             
            <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
                </div>
                <div  style="line-height:30px;" >{{prompt}} </div>
                <span slot="footer"  :style="{'height':'40px' }">
                    <el-button size="small" type="primary" @click="cfmDlg">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 上传进度 -->
            <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                    <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
                </div>
                <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
            </el-dialog>
            <el-dialog v-dialogDrag :visible.sync="showViewer" width="800px" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预览</span>
                </div>
                <el-image fit="scale-down"  style=" margin:5px auto;height:500px;width:100% " :src="listurl"></el-image>
            </el-dialog>
            <!-- 联系人资料框 -->
            <el-dialog  v-dialogDrag :visible.sync="perWin"  width="1200px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{perFlag==='create'?'新增记录':'编辑记录'}}</span>
                </div>
                <Form :model="contRow" :label-width="120"  label-position="right" inline :rules="perValidate" >  
                    <span v-for="(item,index) in perCol" :key="index" >
                        <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                            <el-date-picker type="date"  v-if="item.edcss==='date'" v-model="contRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                            <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="contRow[item.key]" style="width:100%"></el-checkbox> 
                            <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="contRow[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form> 
                <span slot="footer"  >
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="perWin=false" style="margin-right:25px;">取消</el-button>
                    <el-button  type="primary" size="small" icon="iconfont icon-baocun"  @click="perSure" style="margin-right:10px;">确定</el-button>
                </span>
            </el-dialog>
            <!-- 验证手机号 -->
            <el-dialog  v-dialogDrag :visible.sync="telWin" :show-close="false" width="530px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">手机验证</span>
                </div>
 
                <div style="margin-top:20px;">
                     <el-input autocomplete="off" type="text"   v-model="phoneno"  disabled style="width:500px; ">
                        <div slot="prepend" style="width:120px;text-align:right;margin-right:20px;  " >绑定手机号码</div> 
 
                    </el-input>
                </div>
                <div style="margin-top:20px;">
                     <el-input autocomplete="off" type="text" placeholder="请输入手机验证码" v-model="telcode" onkeyup="value=value.replace(/[^\d]/g,'')" style="width:500px; ">
                        <div slot="prepend" style="width:120px;text-align:right;margin-right:20px;  " >手机验证码</div> 
                        <div style="width:110px;text-align:center" slot="append">
                            <el-link :underline="false" v-show="sendAuthCode" type="primary"  @click="getAuthCode" style="color:#19be6b;">获取验证码</el-link>
                            <div v-show="!sendAuthCode" >{{auth_time}}秒后重新发送</div>
                        </div>
                    </el-input>
                </div>
                <span slot="footer"  >
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="telWin=false" style="margin-right:35px;">取消</el-button>
                    <el-button  type="primary" size="small" icon="iconfont icon-baocun"  @click="telSure" style="margin-right:10px;">确定</el-button>
                </span>
            </el-dialog>
        </div>
</template>

<script>
import {  getDate} from '../../api/Select'
import { getTabColOrData,getBaseData } from '../../api/user'
export default {
        name: "supplyRegister", 
        data () {
            return {
                phoneno:'',
                telcode:'',
                telWin:false,
                v_css:'true',
                LANG:'CN',
                listurl:'',
                areaArr: [],
                comboArr:[],
                formArr:[],
                Accept: "png,jpg,jpeg,gif,tiff,pdf", //上传文件格式限制
                sendAuthCode:true,/*布尔值，通过v-show控制显示 获取按钮 还是 倒计时  */
                auth_time: 0, 
                perCol:[],
                userno:'',
                perRow:{},
                v_formurl:'xuper_auth/getFormGroup', 
                uploadData:{}, //上传数据
                promptWin:false,
                prompt:'',
                videoFlag:false,
                videoUploadPercent:0,
                showViewer:false,
                MERPATH:'',
                MERPATH2:'',
                MERPATH3:'',
                CRTPATH:'',
                CRTPATH2:'',
                CRTPATH3:'',
                v_corpid: '14459',//api 请求密码
                form:{
                    userno:'',//请输入手机号
                    code:'',//获取校验码                   
                    pwd:'',
                    read:'N',
                    nation:'', //区号
                    usernm:'',
                    corpnm:'', //企业名
                    field:'', //行业
                    emplvl:'', //规模人数
                },
                perData:[],
                dlgFlag:'N',
                contRow:{},
                perFlag:'create',
                perWin:false,
                rowIndex:'',
                stfgBool:true,
                ruleValidate:{},
                notNull:[],
                imgData:[],
                delImg:[],
                uploadUrl:'xuper_auth/uploadImg',
                fileName:'',
                perValidate:{'EMPNM':[{ required: true, message: '请输入员工姓名', trigger: 'blur' }],'TELNO':[{ required: true, message: '请输入手机号码', trigger: 'blur' }]},
            }
        },
        created () {
            this.perRow['SUPTY'] ='397185'  //注册供应商
            this.perRow['CRCY'] ='4238'
        },
        computed: {
 
            tabHeight: function() {
                return (window.innerHeight - 160) + 'px';
            }, 
        },
        mounted() {
            this.form.nation ='0086'
            this.comSelect()
            //国家地区
            getBaseData('xuper_auth/getCascadeData','parentno','308' ,'','','v_sys_base','').then(res=>{
                this.areaArr =res.result
            })
            //表单资料分组 
            getTabColOrData(this.v_formurl,'','','v_sys_form_fld','idseq','100','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
                this.formArr = res.result             
            })
            getTabColOrData('xuper_auth/getBaseData','','','v_sys_form_fld','idseq','100','lstseq','3','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    this.perCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            //动态生成表单验证规则
            getTabColOrData('xuper_auth/getBaseData','','','v_sys_form_fld','idseq','100','LSTSEQ','1','NOTNULL','Y').then((res) => {
                let ruleObj={}
                let ruleVal=[]
                this.notNull = res.result
                res.result.forEach(item => {
                    let v_fldnm =item.FLDNM
                    let obj1={required:true,  trigger: 'blur'}
                    ruleVal =[]
                    ruleVal.push(obj1)
                    ruleObj[item.FLDNO]=ruleVal                  
                });
                this.ruleValidate =ruleObj
            })
        },
        methods: {
            cfmDlg(){
                this.promptWin = false
                if (this.dlgFlag =='Y'){
                   this.mainPage() 
                }
            },
            telSure(){
                if (!this.phoneno){
                    this.promptWin =true
                    this.prompt ='绑定手机号不能为空'
                }else if (!this.telcode){
                    this.promptWin =true
                    this.prompt ='请输入手机验证码'
                }else {
                    //短信验证码 10分钟有效 及合法性判断
                    this.$axios({
                        method:'post', 
                        url: 'xuper_auth/regMessage' ,
                        data:{  //get这里应为params //请求参数
                            telno :this.phoneno,
                            code :this.telcode,
                        },
                    }).then(res =>{
                        if (res.code === '200'){
                            var area_=''
                            var vm =this 
                            if (typeof(this.perRow['AREA'])!=='undefined' && this.perRow['AREA']!==''){
                                area_ =this.perRow['AREA'].join(',') 
                            } 
                            this.telWin =false
                            this.$confirm('在提交前请确认资料的填写完整，以便于系统审核通过，确定要提交吗','提示',{
                                confirmButtonText: '确定',
                                cancelButtonText:'取消',
                                customClass:'messageBox',
                                showClose:false,
                                closeOnClickModal:false,
                                closeOnPressEscape:false,
                                type:'info',
                            }).then(()=>{
                                let obj_ ={}      
                                Object.assign(obj_,vm.perRow,{'AREA': area_, 'CORPID':this.v_corpid,ISREG:'Y'}) 
                                this.$axios({
                                    method: 'post',
                                    url: 'xuper_auth/formOneSave',
                                    data: {p_json:JSON.stringify(obj_), p_table:'bs_sup',frmid:'100'},
                                }).then(res=>{    
                                    let v_idseq = res.idseq 
                                    if(res.result ==='OK')  {  
                                        //联络人保存：批量保存  res.idseq
                                        this.$axios({   
                                            method: 'post',
                                            url:'xuper_auth/batDtlSave?',
                                            data: {p_json:JSON.stringify(this.perData), p_table:'BS_supEMP',p_idseq:v_idseq,p_action:'S' },
                                        }).then(res=>{
                                            if (res.code!=='200'){
                                                this.promptWin=true
                                                this.prompt=res.result
                                            }else{
                                                this.$axios({
                                                    method:'post', 
                                                    url: 'xuper_auth/getBaseData' ,
                                                    data:{p_table:'v_bs_sup',p_key:'idseq',p_value:v_idseq },
                                                }).then(res =>{
                                                    this.dlgFlag='Y'
                                                    this.promptWin =true
                                                    this.prompt='已成功注册，编码：'+res.result[0]['IDNO']+',请记下来，待系统审核后用绑定的手机号码登录，初始密码为：2022,登录系统后可自行修改密码'
                                                })
                                            }
                                        })

                                    }else{
                                        this.$alert(res.result, '提示', {
                                            confirmButtonText: '确定',
                                            showClose:false,
                                            type:'info'
                                        })
                                    }        
                                }) 
                            }).catch(err=>{})
                        }else{
                            this.$alert(res.message, '提示', {
                                confirmButtonText: '确定',
                                showClose:false,
                                type:'info'
                            })
                        }
                    })
                }
            },
            perSure(){
                if (!this.contRow['EMPNM']){
                    this.promptWin=true
                    this.prompt='姓名不能为空'
                }else if (!this.contRow['TELNO']){
                    this.promptWin=true
                    this.prompt='手机号码不能为空'
                }else{
                    this.perWin =false
                    if (this.perFlag==='edit' ){ //编辑时要替换数组记录
                        this.perData.splice(this.rowIndex,1,this.contRow)
                    }else{
                        this.perData.push(this.contRow)
                    }
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.pertab.doLayout();
                    })
                }
            },
            //保存记录
            saveRec(){
                let vm =this
                this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                    if (!this.perRow[item.FLDNO] ){
                        this.stfgBool =false 
                        this.promptWin =true
                        this.prompt=item.FLDNM+'不能为空'
                        return true
                    }else{
                        this.stfgBool =true  
                    }
                })
                //发起保存请求   
                if (this.stfgBool) {   
                    var telchk=/^1[3456789]\d{9}$/
                    if (!telchk.test(this.perRow['PHONENO'])) {
                        this.prompt ='绑定手机号码格式错误, 请重新输入'  
                        this.promptWin=true          
                    }
                    // else if (!this.perRow['MERPATH']&&!this.perRow['MERPATH2']&&!this.perRow['MERPATH3']){
                    //     this.prompt ='请上传营业执照'  
                    //     this.promptWin=true 
                    // }
                    else{
                        //暂进屏蔽手机短信验证功能
                        //this.telWin =true
                        //this.phoneno =this.perRow['PHONENO']
                        var area_=''
                        if (typeof(this.perRow['AREA'])!=='undefined' && this.perRow['AREA']!==''){
                            area_ =this.perRow['AREA'].join(',') 
                        } 
                        this.$confirm('在提交前请确认资料的填写完整，以便于系统审核通过，确定要提交吗','提示',{
                                confirmButtonText: '确定',
                                cancelButtonText:'取消',
                                customClass:'messageBox',
                                showClose:false,
                                closeOnClickModal:false,
                                closeOnPressEscape:false,
                                type:'info',
                        }).then(()=>{
                            //判断供应商名称与手机号码是否已注册提醒
                            this.$axios({
                                method: 'post',
                                url: 'xuper_auth/getRecordCnt',
                                data: {p_cond:' and (lower(supnm)=lower(\''+this.perRow['SUPNM']+'\') OR PHONENO=\''+this.perRow['PHONENO']+'\')',p_table:'bs_sup' },
                            }).then(res=>{  
                                if (res.result!== 0){
                                    this.prompt ='供应商名称或绑定手机号码已注册，请联系管理员'
                                    this.promptWin =true
                                }else{
                                    let obj_ ={}      
                                    Object.assign(obj_,vm.perRow,{'AREA': area_, 'CORPID':this.v_corpid,ISREG:'Y'}) 
                                    this.$axios({
                                        method: 'post',
                                        url: +'xuper_auth/formOneSave',
                                        data: {p_json:JSON.stringify(obj_), p_table:'bs_sup',frmid:'100'},
                                    }).then(res=>{    
                                        let v_idseq = res.idseq 
                                        if(res.result ==='OK')  {  
                                            //联络人保存：批量保存  res.idseq
                                            this.$axios({   
                                                method: 'post',
                                                url:'xuper_auth/batDtlSave?',
                                                data: {p_json:JSON.stringify(this.perData), p_table:'BS_supEMP',p_idseq:v_idseq,p_action:'S' },
                                            }).then(res=>{
                                                if (res.code!=='200'){
                                                    this.promptWin=true
                                                    this.prompt=res.result
                                                }else{
                                                    this.$axios({
                                                        method:'post', 
                                                        url: 'xuper_auth/getBaseData' ,
                                                        data:{p_table:'v_bs_sup',p_key:'idseq',p_value:v_idseq },
                                                    }).then(res =>{
                                                        this.dlgFlag='Y'
                                                        this.promptWin =true
                                                        this.prompt='已成功注册，编码：'+res.result[0]['IDNO']+',请记下来，待系统审核后用绑定的手机号码登录，初始密码为：2022,登录系统后可自行修改密码'
                                                    })
                                                }
                                            })

                                        }else{
                                            this.$alert(res.result, '提示', {
                                                confirmButtonText: '确定',
                                                showClose:false,
                                                type:'info'
                                            })
                                        }        
                                    }) 
                                }
                            })
                        }).catch(err=>{})
                    }
                }
            },
            //图片预览
            imgPreview(path){
                if (path &&path.indexOf('.pdf')>-1){
                let routeUrl = this.$router.resolve({
                        path: '/fullPreview',
                        query: {fileUrl: path},
                    });
                    window.open(routeUrl.href, '_blank');
                }else{
                    this.showViewer=true
                    this.listurl=path
                }
            },
            //图片删除，操作数组
            imgDel(type, index){
                this.$confirm('你确定要删除此图片吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    if (index==0 && type=='MER'){
                        Object.assign(this.perRow,{MERPATH:''}) 
                        this.MERPATH =''
                    }else if (index==1 && type=='MER'){
                        Object.assign(this.perRow,{MERPATH2:''}) 
                        this.MERPATH2 =''
                    }else if (index==2 && type=='MER'){
                        Object.assign(this.perRow,{MERPATH3:''}) 
                        this.MERPATH3 =''
                    }else if (index==0 && type=='CRT'){
                        Object.assign(this.perRow,{CRTPATH3:''}) 
                        this.CRTPATH =''
                    }else if (index==1 && type=='CRT'){
                        Object.assign(this.perRow,{CRTPATH2:''}) 
                        this.CRTPATH2 =''
                    }else if (index==2 && type=='CRT'){
                        Object.assign(this.perRow,{CRTPATH3:''}) 
                        this.CRTPATH3 =''
                    }              
                }).catch(()=>{})
            },
            //上传显示进度
            handleProgress(event,file,fileList){
                this.videoFlag = true
                this.videoUploadPercent = Math.floor(event.percent)
            },
            //文件格式验证错误时的钩子
            handleFormatError (file) {
                this.promptWin =true
                this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择图片或PDF文件格式'
            },
            //文件超出指定文件大小限制的钩子
            handleMaxSize (file) {
                this.promptWin =true
                this.prompt=file.name + ' 文件太大, 不能超出10M' 
            },
            // 文件上传成功时的钩子
            successImgFile(res,file){
                this.videoUploadPercent=0 
                this.videoFlag = false
                let v_filename='/assets/basedict/'+this.fileName+file.name.substring(file.name.indexOf('.')) 
                if (!this.MERPATH ){
                    this.MERPATH =v_filename
                    Object.assign(this.perRow,{MERPATH:v_filename})               
                }else if (!this.MERPATH2 ){
                    this.MERPATH2 =v_filename
                    Object.assign(this.perRow,{MERPATH2:v_filename})               
                }else if (!this.MERPATH3 ){
                    this.MERPATH3 =v_filename
                    Object.assign(this.perRow,{MERPATH3:v_filename})               
                } 
            },
            successCrtFile(res,file){
                this.videoUploadPercent=0 
                this.videoFlag = false
                let v_filename='/assets/basedict/'+this.fileName+file.name.substring(file.name.indexOf('.')) 
                if (!this.CRTPATH ){
                    this.CRTPATH =v_filename
                    Object.assign(this.perRow,{CRTPATH:v_filename})               
                }else if (!this.CRTPATH2 ){
                    this.CRTPATH2 =v_filename
                    Object.assign(this.perRow,{CRTPATH2:v_filename})               
                }else if (!this.CRTPATH3 ){
                    this.CRTPATH3 =v_filename
                    Object.assign(this.perRow,{CRTPATH3:v_filename})               
                }  
            },
            //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
            beforeImgFile (res, file) {                              
                this.fileName= this.v_username+getDate('year')+'-reg'     
                this.uploadData = {
                    code: this.fileName
                }
                let promise = new Promise(resolve => {
                this.$nextTick(function() {
                        resolve(true);
                    });
                });
                return promise; 
            },
 
            perEdit(row ,index){
                this.contRow=JSON.parse(JSON.stringify(row))
                this.perWin=true
                this.perFlag='edit'
                this.rowIndex=index
            } ,
            perDel(row,index){
                this.$confirm('你确定要删除此行记录吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.perData.splice(index,1)
                }).catch(()=>{})
            },
            //动态赋值下拉框
            comSelect(){  
                this.$axios({
                    method:'post', 
                    url: 'xuper_auth/getBaseData' ,
                    data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'100',p_cond:' and lstseq in (1,2,3)' ,p_key3:'edcss',p_value3:'select'},
                }).then(res =>{
                    if (res.result.length>0){
                        for(let k=0;k<res.result.length;k++){
                            getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                                this.comboArr[res.result[k].FLDNO] =res2.result
                            })
                        }
                    }
                })  
            },
            perAdd(){
                this.contRow={'STFG':'N'}
                this.perFlag='create'
                this.perWin=true
            },
 
            //注册供应商
            mainPage(){
                let routeUrl = this.$router.resolve({
                    path: '/',
                    query: {lang:this.LANG },
                });
                window.open(routeUrl.href, '_self');
            },
 
            //手机短信验证
            btnMsg() {
                if (!this.form.userno){
                    this.$Message.error('请输入常用手机号码')
                }else if (!this.form.code){
                    this.$Message.error('请输入手机验证码')
                }else if (this.form.pwd.length<6){
                    this.$Message.error('请输入不少于6位数密码')
                }else {
                    //短信验证码 10分钟有效 及合法性判断
                    this.$axios({
                        method:'post', 
                        url: 'xuper_auth/regMessage' ,
                        data:{  //get这里应为params //请求参数
                            telno :this.form.userno,
                            code :this.form.code,
                        },
                    }).then(res =>{
                        this.promptWin =true
                        this.prompt ='Successfully'
                    }) 

                }
            },
            //获取验证码
            getAuthCode() {
                if (!this.phoneno){
                    this.promptWin =true
                    this.prompt ='请输入手机号码'
                }else {
                    let area_ = 'china'
                    //消息验证
                    this.$axios({
                        method:'post', 
                        url: 'xuper_auth/sendMessage' ,
                        data:{  //get这里应为params //请求参数
                            telno :this.phoneno,
                            area :area_,
                            areano:'0086'
                        },
                    }).then(res =>{
                        if (res.code === 'OK'){
                            this.sendAuthCode = false;
                            this.auth_time = 60;
                            var auth_timetimer =  setInterval(()=>{
                                this.auth_time--;
                                if(this.auth_time<=0){
                                    this.sendAuthCode = true;
                                    clearInterval(auth_timetimer);
                                }
                            }, 1000);
                        }else{
                            this.$alert(res.message, '提示', {
                                confirmButtonText: '确定',
                                showClose:false,
                                type:'info'
                            })
                        }
                    }) 
                }
            },
        }
    }
</script>

<style scoped>
    .bottomdiv{
        background:#e8eaec;
        height:50px;
        line-height:50px;
        margin-top:1px ;
    }
    .bottombtn{
        height:50px;
        background:#67C23A;
        width:175px;
        color:white;
        font-size:16px;
    }
    .paybtn:hover{
        background:#E6A23C;
    }
    .paybtn{
        height:50px;
        background:#F56C6C;
        width:120px;
        color:white;
        font-size:18px;
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
        text-align:left;
    }
    .item-width2  {
        width: 98%;
        color:#409EFF;
    }
    .main_back{
        height: 100vh;
        margin:0px auto;  
        width:1230px;
        border:1px solid #fff;
        background: #f8f8f9;
         
    }
    .main_back2{
        height: 92vh;
 
    }
</style>
<style lang="less">
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 25px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
    .el-cascader-panel{
        height: 60vh;
        .el-scrollbar__wrap{
            height:100%;
        }
    }
</style>
